import api from "./apiBase";

export const sendContactMessage = async (payload) => {
  return api.post("/contact", payload);
};
